import HaltInstructionSegment from 'app/src/engine/instructions/HaltInstructionSegment';
import Instruction from 'app/src/engine/instructions/Instruction';

export default class HaltInstruction extends Instruction {
	get basePriority(): number {
		return 100;
	}

	constructor() {
		super();

		this.reset();
	}

	// Interactions need to be reset after being used.
	public reset(): void {
		// Create segments.
		this._remainingSegments = [new HaltInstructionSegment()];
	}
}
